export default __webpack_public_path__ + "static/media/Back-open_medium.45dd4513.jpg";